import React, {useEffect, useState} from "react";
import styled from "styled-components";
import {Button, Descriptions, Image, message} from "antd";
import {useStore} from "../../store";
import {downLoadImageByUrl, getImageName, getImageUrlName} from "../../utils/imageUtil";
import {showFullScreenLoading, tryHideFullScreenLoading} from "../../config/serviceLoading";
import {getWaterMarkImage} from "../../http/manager";
import {BaseImageUrl} from "../../http/http";
import {observer} from "mobx-react";
import {AtlasEntity} from "../../entity/atlas-entity";

const defaultIcon = require("../../image/default-pic.png")
interface CommonDetailProps {
    detail:AtlasEntity|undefined;
}
const DnaDetail:React.FC<CommonDetailProps> = ({detail}) => {

    const [loadImageUrl, setLoadImageUrl] = useState("");


    useEffect(()=> {
        if (detail) {
            getWaterMarkPicture();
        }
    }, [])

    const getWaterMarkPicture = () => {
        if (!detail) return
        const param = {
            imageName: getImageName(detail.imgUrl),
        }
        showFullScreenLoading()
        getWaterMarkImage(param)
            .then((res) => {
                tryHideFullScreenLoading()
                setLoadImageUrl(BaseImageUrl+detail.imgUrl);
            })
            .catch(() => {
                tryHideFullScreenLoading();
            })
    }


    const downloadImage = () => {
        if (detail) {
            downLoadImageByUrl(BaseImageUrl+detail.imgUrl, getImageUrlName(detail.imgUrl))
        } else {
            message.error("图片地址获取失败，无法下载！")
        }
    }


    return (<Wrapper>
        <div className="imgBox">
            <Image width={"500px"} src={loadImageUrl} fallback={defaultIcon}/>
        </div>
        <InfoWrapper>
            <Button onClick={downloadImage} style={{width:"100px", marginLeft:"35px", marginBottom:"20px"}} type={"primary"}>下载图片</Button>
            <Descriptions style={{marginLeft: "35px"}} size={"middle"} layout={"horizontal"} bordered={true} column={1}>
                <Descriptions.Item label={"序列编号"}>{detail?.sequenceNumber}</Descriptions.Item>
                <Descriptions.Item label={"采样编号"}>{detail?.sampleNumber}</Descriptions.Item>
                <Descriptions.Item label={"药材名"}>{detail?.medicineName}</Descriptions.Item>
                <Descriptions.Item label={"基原植物"}>{detail?.originalPlant}</Descriptions.Item>
                <Descriptions.Item label={"拉丁名"}>{detail?.latinName}</Descriptions.Item>
                <Descriptions.Item label={"样品来源"}>{detail?.sampleSource}</Descriptions.Item>
                <Descriptions.Item label={"取样部位"}>{detail?.smapleLocation}</Descriptions.Item>
                <Descriptions.Item label={"样品提供单位"}>{detail?.sampleUnit}</Descriptions.Item>
                <Descriptions.Item label={"鉴定人"}>{detail?.appraiser}</Descriptions.Item>
                <Descriptions.Item label={"责任人"}>{detail?.dutyPerson}</Descriptions.Item>
                <Descriptions.Item label={"序列提交时间"}>{detail?.sequenceTime}</Descriptions.Item>
                <Descriptions.Item label={"序列类型"}>{detail?.sequenceType}</Descriptions.Item>
                <Descriptions.Item label={"采集信息"}>{detail?.collectInfo}</Descriptions.Item>
                <Descriptions.Item label={"描述信息"}>{detail?.describeInfo}</Descriptions.Item>
            </Descriptions>
        </InfoWrapper>
    </Wrapper>);
}

export default observer(DnaDetail);


const Wrapper = styled.div`
  & {
    display: flex;
    max-height: 800px;
    overflow: auto;
    flex-direction: row;
    padding: 15px;
    .ant-descriptions.ant-descriptions-bordered .ant-descriptions-item-label {
      background-color: #F9FAFD;
    }
    .ant-descriptions .ant-descriptions-item-content{
      color: #666666;
    }
    .imgBox {
        width: 500px;
        border-radius: 8px;
        border: 1px solid rgba(5, 5, 5, 0.06);
        display: flex;
        align-items: center;
    }
  }
`;
const InfoWrapper = styled.div`

  & {
    display: flex;
    flex-direction: column;
  }
`;